module.exports = __webpack_public_path__ + "static/media/group-quote-placeholder.f14bacca.webp";